export const GENERATIONAL_FUNDS_MODAL_TEXTS = {
  title: 'Preguntas frecuentes de los Fondos',
  closeLabel: 'Cerrar',
  intro:
    'Con la Reforma de Pensiones, los Fondos Generacionales reemplazaron a los multifondos A al E. En tu APV puedes elegir el fondo que prefieras.',
};

export const GENERATIONAL_FUNDS_MODAL_FAQS = [
  {
    question: '¿Qué son los Fondos generacionales?',
    answer:
      'Son fondos de pensiones que agrupan a personas según su fecha de nacimiento. Cada fondo invierte los ahorros de una generación y reduce su nivel de riesgo de forma gradual a medida que esa generación se acerca a la edad de pensión.',
  },
  {
    question: '¿Puedo elegir el Fondo Generacional para mi APV?',
    answer:
      'Sí. Para tu ahorro obligatorio se asigna automáticamente al fondo que corresponde a tu año de nacimiento, pero para tu ahorro voluntario puedes invertirlo en el Fondo Generacional que prefieras.',
  },
  {
    question: '¿Cómo se invierten mis ahorros en un Fondo Generacional?',
    answer:
      'Los ahorros de un Fondo Generacional se invierten en activos de crecimiento y activos de protección. La proporción entre ambos depende de la edad de la generación: los fondos de personas jóvenes invierten más en activos de crecimiento, y los fondos de personas cercanas a la pensión invierten más en activos de protección.',
  },
  {
    question: '¿Todas las AFP invierten igual en los Fondos Generacionales?',
    answer:
      'No necesariamente. Cada AFP define su asignación estratégica, pero todas deben respetar los mismos rangos por tipo de activo y el máximo de activos de crecimiento para cada etapa.',
  },
  {
    question: '¿Qué pasó con los multifondos A, B, C, D y E?',
    answer:
      'Con la Reforma de Pensiones (Ley N° 21.735), los multifondos fueron reemplazados por 10 Fondos Generacionales, que están disponibles desde el 1 de abril de 2027.',
  },
];
